"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var DatePicker_1 = require("office-ui-fabric-react/lib/DatePicker");
var owa_calendar_strings_1 = require("owa-strings/owa-calendar-strings");
var owa_common_strings_1 = require("owa-strings/owa-common-strings");
var React = require("react");
var mobx_1 = require("mobx");
var OWADatePicker = /** @class */ (function (_super) {
    tslib_1.__extends(OWADatePicker, _super);
    function OWADatePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(OWADatePicker.prototype, "datePickerStrings", {
        get: function () {
            return {
                months: [
                    owa_common_strings_1.default.januaryUppercase,
                    owa_common_strings_1.default.februaryUppercase,
                    owa_common_strings_1.default.marchUppercase,
                    owa_common_strings_1.default.aprilUppercase,
                    owa_common_strings_1.default.mayUppercase,
                    owa_common_strings_1.default.juneUppercase,
                    owa_common_strings_1.default.julyUppercase,
                    owa_common_strings_1.default.augustUppercase,
                    owa_common_strings_1.default.septemberUppercase,
                    owa_common_strings_1.default.octoberUppercase,
                    owa_common_strings_1.default.novemberUppercase,
                    owa_common_strings_1.default.decemberUppercase,
                ],
                shortMonths: [
                    owa_common_strings_1.default.januaryAbbreviatedUppercase,
                    owa_common_strings_1.default.februaryAbbreviatedUppercase,
                    owa_common_strings_1.default.marchAbbreviatedUppercase,
                    owa_common_strings_1.default.aprilAbbreviatedUppercase,
                    owa_common_strings_1.default.mayAbbreviatedUppercase,
                    owa_common_strings_1.default.juneAbbreviatedUppercase,
                    owa_common_strings_1.default.julyAbbreviatedUppercase,
                    owa_common_strings_1.default.augustAbbreviatedUppercase,
                    owa_common_strings_1.default.septemberAbbreviatedUppercase,
                    owa_common_strings_1.default.octoberAbbreviatedUppercase,
                    owa_common_strings_1.default.novemberAbbreviatedUppercase,
                    owa_common_strings_1.default.decemberAbbreviatedUppercase,
                ],
                days: [
                    owa_common_strings_1.default.sundayUppercase,
                    owa_common_strings_1.default.mondayUppercase,
                    owa_common_strings_1.default.tuesdayUppercase,
                    owa_common_strings_1.default.wednesdayUppercase,
                    owa_common_strings_1.default.thursdayUppercase,
                    owa_common_strings_1.default.fridayUppercase,
                    owa_common_strings_1.default.saturdayUppercase,
                ],
                shortDays: [
                    owa_common_strings_1.default.sundaySingleLetterAbbreviation,
                    owa_common_strings_1.default.mondaySingleLetterAbbreviation,
                    owa_common_strings_1.default.tuesdaySingleLetterAbbreviation,
                    owa_common_strings_1.default.wednesdaySingleLetterAbbreviation,
                    owa_common_strings_1.default.thursdaySingleLetterAbbreviation,
                    owa_common_strings_1.default.fridaySingleLetterAbbreviation,
                    owa_common_strings_1.default.saturdaySingleLetterAbbreviation,
                ],
                goToToday: owa_calendar_strings_1.default.goToTodayStringLowerCaseText,
            };
        },
        enumerable: true,
        configurable: true
    });
    OWADatePicker.prototype.render = function () {
        return React.createElement(DatePicker_1.DatePicker, tslib_1.__assign({}, this.props, { strings: this.datePickerStrings }));
    };
    tslib_1.__decorate([
        mobx_1.computed
    ], OWADatePicker.prototype, "datePickerStrings", null);
    OWADatePicker = tslib_1.__decorate([
        mobx_react_1.observer
    ], OWADatePicker);
    return OWADatePicker;
}(React.Component));
exports.default = OWADatePicker;
//# sourceMappingURL=OWADatePicker.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-datepicker/lib/components/OWADatePicker.js
// module id = 1870
// module chunks = 2 106 107